export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・Thông tin cần điền vào kế hoạch cải tiến được thể hiện trong {toCompanyName}.\n・Tệp đính kèm được hiển thị trong {toCompanyName} và chỉ có tên tệp sẽ được hiển thị.',
    },
    chat: {
      card_title: 'Tin nhắn',
      input_area_description: 'Bạn có thể gửi tin nhắn đến {toCompanyName} liên quan đến kế hoạch cải tiến',
      send_confirm: {
        modal_title: 'Kiểm tra tin nhắn sẽ được gửi',
        confirm_text: 'Bạn có chắc chắn muốn gửi tin nhắn này không?',
        confirm_text_near_by_check_box: 'Đã kiểm tra tin nhắn',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: 'Xóa tin nhắn này',
        confirm_text: 'Bạn có chắc chắn muốn xóa tin nhắn này không?',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: 'Lịch sử gửi',
        send_status: {
          success: 'Sent',
          failure: 'Không gửi được',
        },
      },
    },
  },
}
